import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { EditableAttributeModalProps } from './ui/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyEditableAttributeModal = lazy(
	() => import(/* webpackChunkName: "editable-attribute-modal" */ './ui/main.tsx'),
);

export const AsyncEditableAttributeModal = (props: EditableAttributeModalProps) => (
	<Placeholder name="editable-attribute-modal" fallback={null}>
		<LazyEditableAttributeModal {...props} />
	</Placeholder>
);
